import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";

import { NavController } from "@ionic/angular";

import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { AppPages } from "../shared/models/app.model";
import { User } from "../shared/models/user.model";
import { RouterStates } from "../shared/consts";
import { StorageService } from "../shared/services/storage.service";

/**
 * Guard that only allows access for users in the openActive state.
 * Used to protect the /open-onboarding route.
 *
 * If user is not in openActive state:
 * - Redirects to their current state's route (using RouterStates mapping)
 * - Falls back to onboarding-intro if no valid route found
 */
@Injectable({
  providedIn: "root",
})
export class OpenActiveGuard {
  private readonly storage = inject(StorageService);
  private readonly navController = inject(NavController);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const user$ = from(this.storage.get("user"));
    return user$.pipe(
      map((user: User) => {
        const isOpenActive = user?.userState?.page === AppPages.openActive;

        if (!isOpenActive) {
          // Redirect to appropriate page based on current state
          const currentState = user?.userState?.page;
          const stateRoute = RouterStates.get(currentState);
          const redirectTo = stateRoute?.redirectTo ?? "onboarding-intro";

          this.navController.navigateRoot(redirectTo, {
            queryParams: route.queryParams,
          });
        }

        return isOpenActive;
      })
    );
  }
}
